export class SignMeasurements {
  width: number;
  height: number;
  value: number;

  constructor(width: number, height: number, value: number) {
    this.width = width;
    this.height = height;
    this.value = value;
  }
}

export const SignMeasurementsChoices = {
  W70_H100: new SignMeasurements(70, 100, 0),
  W100_H140: new SignMeasurements(100, 140, 1),
  W50_H140: new SignMeasurements(50, 140, 2),
  W70_H180: new SignMeasurements(70, 180, 3)
};

export const SignMeasurementsChoiceArray = Object.values(
  SignMeasurementsChoices
);
